module.exports = __webpack_public_path__ + "assets/power.df22054b.svg";